import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applySkin, applyTelegramThemeParams, detectSkin } from './theme';
import { getTelegramWebApp } from './hooks/useTelegramContext';
import { startMocks } from './mocks/browser';
import './theme/theme.css';

// Paint the right palette before React's first render so there is no flash of
// the wrong theme. ThemeProvider takes over from here.
applySkin(detectSkin());
applyTelegramThemeParams(getTelegramWebApp()?.themeParams);

async function bootstrap() {
  // PR6 serves every screen from MSW; PR7 sets VITE_USE_MOCKS=false.
  await startMocks();

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
